import { AuditDocumentsAPI } from "api/api/auditDocumentsApi/auditDocumentsApi";
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { PostAuditDocumentMarkAsReadParams, PostAuditDocumentMarkAsReadResponse } from "api/api/auditDocumentsApi/types";

export const postAuditDocumentMarkAsRead = createAsyncThunk<
  PostAuditDocumentMarkAsReadResponse,
  PostAuditDocumentMarkAsReadParams
>(
  "documents/postAuditDocumentMarkAsRead",
  async (params, { rejectWithValue }) => {
    try {
      const data = await AuditDocumentsAPI.postAuditDocumentMarkAsRead(params);
      return data;
    } catch (error: unknown) {
      if (axios.isAxiosError(error)) {
        console.error(
          "Error while marking audit document as read",
          error.response?.data
        );
        return rejectWithValue(error.response?.data || "Unknown error");
      } else {
        console.error("Error while marking audit document as read", error);
        return rejectWithValue(
          "Что-то пошло не так... Попробуйте обновить страницу"
        );
      }
    }
  }
);
